import { FilterItemType } from '../types/types';
import { getDefaultMatchModeByType } from './managerUtils';

export const getDefaultMatchMode = (filterItem: FilterItemType) => {
  if (filterItem.default?.matchMode) {
    if (
      filterItem.type === 'dateTime' ||
      filterItem.control?.type === 'dateTime'
    ) {
      switch (filterItem.default.matchMode) {
        case 'equals':
        case 'dateIs':
          return 'datetime-equals';
        case 'between':
          return 'datetime-between';
        case 'notEquals':
        case 'dateIsNot':
          return 'datetime-notEquals';
        default:
          return filterItem.default.matchMode;
      }
    }
    return filterItem.default.matchMode;
  }
  if (filterItem.control?.type === 'reference') {
    if (filterItem.control.multiSelect) {
      return 'in';
    }
    return 'equals';
  }
  if (
    filterItem.control?.type === 'radioBtn' ||
    filterItem.control?.type === 'combobox'
  ) {
    return 'equals';
  }
  return getDefaultMatchModeByType(filterItem.type, filterItem.control?.type);
};
